import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';

/**
 * Skeleton loader component that precisely mimics the ScanCard layout
 * for a smoother, more realistic loading experience.
 * Use copilot to update with changes in the future!
 */
const SkeletonScanCard = () => {
  return (
    <Card
      sx={{
        minWidth: '90px',
        minHeight: '100px',
      }}
      variant='outlined'
      elevation={0}
    >
      <CardContent sx={{ position: 'relative', p: 2 }}>
        {/* Header row with block name and status indicator */}
        <Stack
          direction='row'
          justifyContent='space-between'
          alignItems='center'
          sx={{ mb: 1 }}
        >
          {/* Block name */}
          <Skeleton
            variant='text'
            width='70%'
            height={28}
            animation='wave'
            sx={{ borderRadius: '4px' }}
          />

          {/* Status indicator circle */}
          <Skeleton
            variant='circular'
            width={16}
            height={16}
            animation='wave'
          />
        </Stack>

        {/* Date */}
        <Skeleton
          variant='text'
          width='40%'
          height={18}
          animation='wave'
          sx={{ mb: 0.5, borderRadius: '4px' }}
        />

        {/* Ranch name */}
        <Skeleton
          variant='text'
          width='60%'
          height={18}
          animation='wave'
          sx={{ borderRadius: '4px' }}
        />
      </CardContent>
    </Card>
  );
};

/**
 * Grid of skeleton cards that match the layout of the scan list
 * @param numCards The number of skeleton cards to display
 */
export const ScanListSkeleton = ({ numCards = 25 }: { numCards?: number }) => {
  // Show a grid of skeleton cards
  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Grid container spacing={'0.625rem'} columns={10}>
        {Array.from(new Array(numCards)).map((_, index) => (
          <Grid key={index} size={{ xl: 2, lg: 2, md: 3, sm: 5, xs: 10 }}>
            <SkeletonScanCard />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
